import * as R from 'ramda';

const idx_data_pap_v_array = [];

let order = 0;
let i = 0;

idx_data_pap_v_array.push({
  pap_v: '',
  order_idx: -1,
});

for (let j = 0; j <= 3; j++) {
  if (j > 0) {
    i = j;
  } else {
    i = '';
  }

  if (j > 0) {
    idx_data_pap_v_array.push({
      pap_v: i + '',
      order_idx: order,
    });
    order++;
  }

  idx_data_pap_v_array.push({
    pap_v: i + ' 1/16',
    order_idx: order,
  });
  order++;

  idx_data_pap_v_array.push({
    pap_v: i + ' 1/8',
    order_idx: order,
  });
  order++;

  idx_data_pap_v_array.push({
    pap_v: i + ' 3/16',
    order_idx: order,
  });
  order++;

  idx_data_pap_v_array.push({
    pap_v: i + ' 1/4',
    order_idx: order,
  });
  order++;

  idx_data_pap_v_array.push({
    pap_v: i + ' 5/16',
    order_idx: order,
  });
  order++;

  idx_data_pap_v_array.push({
    pap_v: i + ' 3/8',
    order_idx: order,
  });
  order++;

  idx_data_pap_v_array.push({
    pap_v: i + ' 7/16',
    order_idx: order,
  });
  order++;

  idx_data_pap_v_array.push({
    pap_v: i + ' 1/2',
    order_idx: order,
  });
  order++;

  idx_data_pap_v_array.push({
    pap_v: i + ' 9/16',
    order_idx: order,
  });
  order++;

  idx_data_pap_v_array.push({
    pap_v: i + ' 5/8',
    order_idx: order,
  });
  order++;

  idx_data_pap_v_array.push({
    pap_v: i + ' 11/16',
    order_idx: order,
  });
  order++;

  idx_data_pap_v_array.push({
    pap_v: i + ' 3/4',
    order_idx: order,
  });
  order++;

  idx_data_pap_v_array.push({
    pap_v: i + ' 13/16',
    order_idx: order,
  });
  order++;

  idx_data_pap_v_array.push({
    pap_v: i + ' 7/8',
    order_idx: order,
  });
  order++;

  idx_data_pap_v_array.push({
    pap_v: i + ' 15/16',
    order_idx: order,
  });
  order++;
}

export const idx_data_pap_v = R.filter(item => item.order_idx < 48)(
  idx_data_pap_v_array
);
